module.exports = __webpack_public_path__ + "static/media/3Anniversary.1a3c8cb9.png";